module.exports = __webpack_public_path__ + "img/album11_02.cbe39d83.jpg";